<template>
  <div class="grid">
    <div class="col-12 md:col-8 lg:col-6 md:col-offset-2 lg:col-offset-3">
      <div class="card">
        <div class="flex flex-column align-items-center text-center mb-4">
          <div class="profile-avatar">
            {{ initials }}
          </div>
          <h4 class="mt-3 mb-1">
            {{ fullName }}
          </h4>
          <span class="text-500">{{ user && user.email }}</span>
        </div>

        <ul class="list-none p-0 m-0">
          <li
            v-for="row in details"
            :key="row.label"
            class="flex justify-content-between align-items-center py-3 border-top-1 surface-border"
          >
            <span class="text-500">{{ row.label }}</span>
            <span class="text-900 font-medium">{{ row.value }}</span>
          </li>
        </ul>

        <div class="flex justify-content-end mt-4">
          <Button
            label="Sign out"
            icon="pi pi-sign-out"
            class="p-button-outlined p-button-danger"
            @click="logout"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: s => s.auth.user
    }),
    ...mapGetters({
      userID: 'auth/getUserID'
    }),
    fullName () {
      if (!this.user) return ''
      return [this.user.first_name, this.user.last_name].filter(Boolean).join(' ') || this.user.email
    },
    initials () {
      const source = this.fullName || (this.user && this.user.email) || '?'
      return source
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase()
    },
    details () {
      const u = this.user || {}
      return [
        { label: 'First name', value: u.first_name || '—' },
        { label: 'Last name', value: u.last_name || '—' },
        { label: 'Email', value: u.email || '—' },
        { label: 'User ID', value: u.id || '—' }
      ]
    }
  },
  mounted () {
    if (!this.user && this.userID) {
      this.fetchUser(this.userID)
    }
  },
  methods: {
    ...mapActions({
      fetchUser: 'auth/getUser'
    }),
    logout () {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.profile-avatar {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: var(--primary-color);
  color: var(--primary-color-text);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: 600;
}
</style>
